export const PROGRESS_VERIFICATION_REPORT_STATUS = {
  WRITE: "ON_WRITE",
  REVIEW: "ON_REVIEW",
  DISTRIBUTION_DONE: "DISTRIBUTION_DONE",
};
